<template>
  <section
    v-if="suggestedContent"
    :class="{ 'bg-www-color-white pt-8': true }"
    data-testid="SuggestedContent"
  >
    <div :class="{ 'container mx-auto grid gap-14 px-4 pb-24 lg:px-0': true }">
      <h2 :class="{ 'text-center text-28px font-black text-www-color-neutral-medium-dark': true }">
        {{ suggestedTitle }}
      </h2>

      <ul :class="{ 'grid grid-cols-1 gap-x-6 gap-y-4 md:grid-cols-3': true }">
        <CardBlog
          v-if="pageType === 'blog' && randomCaseStudy"
          :blog="randomCaseStudy"
          :is-featured="true"
          :hide-image-on-mobile="false"
        />
        <CardBlog
          v-for="blog in suggestedContent.slice(0, 3)"
          :key="blog._id"
          :blog="blog"
          :hide-image-on-mobile="false"
        />
      </ul>
    </div>
  </section>
</template>

<script lang="ts" setup>
import CardBlog from '~/components/Molecules/CardBlog/CardBlog.vue';
import { suggestedContentQuery } from '../../../queries/components/Organisms/SuggestedContent.query';
import type { SuggestedContentQueryResult } from '~/sanity/types';

type Variant = 'blog' | 'video';

interface Props {
  variant?: Variant;
  pageType?: string;
  suggestedTitle?: string;
}

const props = withDefaults(defineProps<Props>(), {
  variant: 'blog',
  pageType: '',
  suggestedTitle: 'Latest Content',
});

const { data: suggestedContent } = await useWwwSanityQueryNonNull<SuggestedContentQueryResult>(
  suggestedContentQuery,
  {
    type: props.variant,
  }
);

const { data: caseStudiesContent } = await useWwwSanityQueryNonNull<SuggestedContentQueryResult>(
  suggestedContentQuery,
  {
    type: 'caseStudy',
  }
);
const { data: randomCaseStudy } = await useAsyncData('randomCaseStudy', async () => {
  if (caseStudiesContent.value && caseStudiesContent.value.length > 0) {
    const idx = Math.floor(Math.random() * caseStudiesContent.value.length);
    return caseStudiesContent.value[idx];
  }
  return null;
});
</script>
